import { HttpContext, HttpContextToken } from '@angular/common/http';

// Tags a request as targeting a PUBLIC_ACCESS backend endpoint so authInterceptor
// skips the Authorization header. Authenticated endpoints just omit the tag.
export const PUBLIC_API = new HttpContextToken<boolean>(() => false);

/** Request option that marks a call public: `http.post(url, body, publicApi())`. */
export const publicApi = (): { context: HttpContext } => ({
  context: new HttpContext().set(PUBLIC_API, true),
});
